import axios from "axios";
import { SESSION_STORE_CONSTANTS } from "../constants/sessionStore";

const baseURL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_SERVICE_URL
    : process.env.REACT_APP_SERVICE_URL_DEV;

export const axiosClient = axios.create({
  baseURL,
});

axiosClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem(SESSION_STORE_CONSTANTS.TOKEN);

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
